import { render, staticRenderFns } from "./WashRequestWeek.vue?vue&type=template&id=5e63383a&scoped=true"
import script from "./WashRequestWeek.vue?vue&type=script&lang=js"
export * from "./WashRequestWeek.vue?vue&type=script&lang=js"
import style0 from "./WashRequestWeek.vue?vue&type=style&index=0&id=5e63383a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e63383a",
  null
  
)

export default component.exports